import { formatChartTickValue } from '../chartAxis';

export function formatShortDate(value?: string | null): string {
  if (!value) {
    return '—';
  }

  const date = new Date(`${value}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatChartDate(value: string): string {
  return formatChartTickValue(value);
}

export function formatWeekBarLabel(weekEnding: string, latestEnding: string): string {
  const ending = new Date(`${weekEnding}T00:00:00Z`);
  const latest = new Date(`${latestEnding}T00:00:00Z`);
  if (Number.isNaN(ending.getTime()) || Number.isNaN(latest.getTime())) {
    return weekEnding;
  }

  const weeksAgo = Math.round((latest.getTime() - ending.getTime()) / (7 * 24 * 60 * 60 * 1000));
  if (weeksAgo <= 0) {
    return 'Today';
  }

  if (weeksAgo === 1) {
    return '1 week ago';
  }

  return `${weeksAgo} weeks ago`;
}

export function formatWeekRange(weekEnding: string, todayUtc?: string): string {
  const ending = new Date(`${weekEnding}T00:00:00Z`);
  if (Number.isNaN(ending.getTime())) {
    return weekEnding;
  }

  const today = todayUtc ?? new Date().toISOString().slice(0, 10);
  const visibleEnd = weekEnding > today ? today : weekEnding;
  const start = new Date(ending);
  start.setUTCDate(start.getUTCDate() - 6);
  return `${formatChartDate(start.toISOString().slice(0, 10))} – ${formatChartDate(visibleEnd)}`;
}
